import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import {
  isNetworkHttpError,
  NetworkConnectivityService,
} from '../services/network-connectivity.service';

function tracksConnectivity(reqUrl: string): boolean {
  return (
    reqUrl.includes('/api/') ||
    reqUrl.startsWith(environment.baseApiUrl)
  );
}

export const networkConnectivityInterceptor: HttpInterceptorFn = (req, next) => {
  const connectivity = inject(NetworkConnectivityService);
  const track = tracksConnectivity(req.url);

  return next(req).pipe(
    tap(() => {
      if (track) {
        connectivity.reportRequestSuccess();
      }
    }),
    catchError((error: unknown) => {
      if (track && isNetworkHttpError(error)) {
        connectivity.reportRequestFailure(error);
      }
      return throwError(() => error);
    })
  );
};
